import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import Dialog from '../../common/components/Dialog';
import GradesList from '../common/GradesList';
import FontAwesome from 'react-fontawesome';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';

class WeeklyInfo extends Component {
	constructor(props) {
		super(props);
		this.handleWeeklyInfoClick = this.handleWeeklyInfoClick.bind(this);
		this.showWeeklyInfoDialog = this.showWeeklyInfoDialog.bind(this);
		this.hideWeeklyInfoDialog = this.hideWeeklyInfoDialog.bind(this);
		this.handleWeeklyInfoLoad = this.handleWeeklyInfoLoad.bind(this);
		this.showSubgradesDialog = this.showSubgradesDialog.bind(this);
		this.hideSubgradesDialog = this.hideSubgradesDialog.bind(this);
		this.handleGradeSelect = this.handleGradeSelect.bind(this);
		this.state = {
			showWeeklyInfoDialog: false,
			showSubgradesDialog: false,
			selectedSubgrade: null,
		};
	}

	showWeeklyInfoDialog() {
		this.setState({ showWeeklyInfoDialog: true });
	}

	hideWeeklyInfoDialog() {
		this.setState({ showWeeklyInfoDialog: false });
	}

	showSubgradesDialog() {
		this.setState({ showSubgradesDialog: true });
	}

	hideSubgradesDialog() {
		this.setState({ showSubgradesDialog: false });
	}

	handleWeeklyInfoLoad() {
		this.props.onLoadWeeklyInfo(this.state.selectedSubgrade);
	}

	handleGradeSelect(grade) {
		const onSuccess = () => {
			this.setState({ selectedSubgrade: grade }, () => {
				this.hideSubgradesDialog();
				this.showWeeklyInfoDialog();
			});
		};
		this.props.onSubGradeSelect(grade, onSuccess);
	}

	renderSubgradesDialog() {
		const { lesson, grades, t } = this.props;

		let grade = lesson && lesson.grade;
		const gradeSubGrades = grade ? grade.subGrades.map(gradeId => grades[gradeId]).filter(g => g) : [];

		const selectedSubgrade = lesson && lesson.subGrade;
		const header = t('FO_ChildLesson_SelectSubgrade');
		const body = grade && <ReduxBlockUi block={this.props.subGradeBlock} unblock={this.props.subGradeUnblock}>
			<div>
				{selectedSubgrade && <h3>{t('FO_ChildLesson_SelectedSubgrade', { subgrade: selectedSubgrade.name })}</h3>}
				<div style={{ marginBottom: '10px' }}>{t('FO_ChildLesson_SelectSubgradeDescription')}</div>
				<GradesList grades={gradeSubGrades} onSelect={this.handleGradeSelect} />
			</div>
		</ReduxBlockUi>;

		return <Dialog show={this.state.showSubgradesDialog} onHide={this.hideSubgradesDialog} header={header} body={body} />;
	}

	renderWeeklyInfoDialog() {
		const { lesson, weeklyInfos, t } = this.props;

		const grade = lesson && (lesson.grade.mixed ? lesson.subGrade || this.state.selectedSubgrade : lesson.grade);
		const weeklyInfo = lesson && grade && weeklyInfos[`${grade.id}|${lesson.weekNumber}`];

		const header = lesson && grade && `${grade.name} - ${t('FO_ChildLesson_Week', { weekNumber: lesson.weekNumber })}`;
		const body = <ReduxBlockUi block={this.props.weeklyInfoBlock} unblock={this.props.weeklyInfoUnblock} renderChildren={false}>
			{weeklyInfo && (weeklyInfo.weeklyInfo ? <div dangerouslySetInnerHTML={{ __html: weeklyInfo.weeklyInfo }} /> : t('FO_ChildLesson_NoWeeklyInfo'))}
		</ReduxBlockUi>;

		return <Dialog show={this.state.showWeeklyInfoDialog} onHide={this.hideWeeklyInfoDialog} onEntered={this.handleWeeklyInfoLoad} header={header} body={body} bsSize='large' />;
	}

	handleWeeklyInfoClick() {
		const { lesson, allowSubGradeChange } = this.props;
		const gradeId = lesson.grade.mixed ? lesson.subGradeId : lesson.gradeId;
		if (!gradeId || (lesson.grade.mixed && allowSubGradeChange)) {
			this.showSubgradesDialog();
		}
		else {
			this.showWeeklyInfoDialog();
		}
	}

	render() {
		const { lesson, showInfo, t, text } = this.props;
		const weekNumber = text || t('FO_ChildLesson_Week', { weekNumber: lesson.weekNumber });
		return <span>
			{showInfo ? <a style={{ cursor: 'pointer' }} onClick={() => this.handleWeeklyInfoClick(lesson)}>{weekNumber}</a> :
				<span>{weekNumber}</span>}

			{this.renderSubgradesDialog()}
			{this.renderWeeklyInfoDialog()}
		</span>;
	}
}

WeeklyInfo.propTypes = {
	lesson: PropTypes.shape({
		weekNumber: PropTypes.number,
		gradeId: PropTypes.number,
		grade: PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string,
			mixed: PropTypes.bool
		}),
		subGradeId: PropTypes.number,
		subGrade: PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string,
			mixed: PropTypes.bool
		})
	}),
	onLoadWeeklyInf: PropTypes.func,
	showInfo: PropTypes.bool,
	allowSubGradeChange: PropTypes.bool,
	onSubGradeSelect: PropTypes.func,
	grades: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	subGradeBlock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	subGradeUnblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	weeklyInfoBlock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	weeklyInfoUnblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	])
};

export default withNamespaces()(WeeklyInfo);